import React from 'react';
import { faTrashCan } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import cs from 'classnames';

import { Box } from 'shared/components/display';
import PromptButton from 'shared/components/molecules/PromptButton';

import { BUTTON_VARIANTS } from 'shared/styles/button';

import styles from './styles';

interface Props {
  onClick: () => void;
  deleteConfirmationText: string;
  confirmButtonText?: string;
  title?: string;
  className?: string;
  variant?: string;
  display?: 'vertical' | 'horizontal';
  hideLabel?: boolean;
}
const DeleteButton: React.FC<Props> = ({
  onClick,
  deleteConfirmationText,
  confirmButtonText,
  title,
  className,
  variant = BUTTON_VARIANTS.TEXT_ONLY,
  display = 'vertical',
  hideLabel = false,
}) => {
  return (
    <Box as="span" css={styles} className={cs('delete-button', className, `delete-button--${display}`)}>
      <PromptButton
        variant={variant}
        onConfirm={onClick}
        className="delete-button__btn"
        text={deleteConfirmationText}
        confirmButtonText={confirmButtonText}
        {...(title && { title })}
      >
        <FontAwesomeIcon icon={faTrashCan} className="delete-button__btn-icon" />
        {hideLabel ? '' : 'Delete'}
      </PromptButton>
    </Box>
  );
};

export default DeleteButton;
